<template>
    <div class="youtube-video-player">
        <YoutubeVideoShadow v-if="!init" :padding="padding" :preview="preview" @click="init = true" />
        <YouTubeVideoPlayerContent
            @timeupdate="$emit('timeupdate', $event)"
            @ready="$emit('ready', $event)"
            @play="$emit('play', $event)"
            @pause="$emit('pause', $event)"
            @ended="$emit('ended', $event)"
            @showDefault="$emit('showDefault')"
            :style="{ paddingBottom: padding }"
            v-if="!didUpdate && init"
            :info-unit-id="infoUnitId"
            :ratio="ratio"
            :is-vertical="isVertical"
            :is-show-preview-on-pause="isShowPreviewOnPause"
            :link="link"
            :host="host"
            :preview="preview"
        />
    </div>
</template>

<script>
import YouTubeVideoPlayerContent from "@components/Players/new/YoutubeVideoPlayerContent.vue"
import YoutubeVideoShadow from "@components/Players/new/YoutubeVideoShadow.vue"

// Global counter for YouTube players on the page (iOS optimization)
if (!window.__youtubePlayerCount) {
    window.__youtubePlayerCount = 0
}

export default {
    components: { YoutubeVideoShadow, YouTubeVideoPlayerContent },
    props: {
        isShowPreviewOnPause: {
            type: Boolean,
            default: false,
            required: false
        },
        ratio: {
            type: Number,
            default: 0,
            required: 0
        },
        isVertical: {
            type: Boolean,
            default: false,
            required: false
        },
        infoUnitId: {
            type: Number,
            default: 0
        },
        link: {
            type: String,
            default: ""
        },
        padding: {
            type: String,
            default: ""
        },
        host: {
            type: String,
            default: ""
        },
        preview: {
            type: String,
            default: ""
        }
    },
    name: "YoutubeVideoPlayer",
    data() {
        return {
            didUpdate: false,
            init: false
        }
    },
    mounted() {
        // Increment global counter
        window.__youtubePlayerCount++

        // On iOS, if there are ≤3 players on the page, auto-initialize to reduce clicks
        const shouldAutoInitOnIOS = this.isIOS() && window.__youtubePlayerCount <= 3

        if (shouldAutoInitOnIOS) {
            console.log(`[YT Player] iOS detected with ${window.__youtubePlayerCount} player(s) - auto-initializing`)
            // Small delay to ensure DOM is ready
            this.$nextTick(() => {
                this.init = true
            })
        }
    },
    beforeDestroy() {
        // Decrement global counter when component is destroyed
        if (window.__youtubePlayerCount > 0) {
            window.__youtubePlayerCount--
        }
    },
    methods: {
        isIOS() {
            // Force iOS mode for testing with ?forceIOS=1
            if (new URLSearchParams(window.location.search).get("forceIOS") === "1") {
                return true
            }

            return (
                ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(
                    navigator.platform
                ) ||
                // iPad on iOS 13 detection
                (navigator.userAgent.includes("Mac") && "ontouchend" in document)
            )
        }
    },
    watch: {
        link() {
            this.didUpdate = true
            setTimeout(() => {
                this.didUpdate = false
            })
        }
    }
}
</script>

